import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { RESERVATION_URL, PROPERTY } from "@/lib/constants";
import { trackClick } from "@/lib/analytics";

export default function StickyBookBar() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (pathname.startsWith("/admin") || pathname === "/login") {
      setVisible(false);
      return;
    }
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  if (!visible) return null;

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-ink/95 backdrop-blur-md border-t border-canvas/15 flex"
      data-testid="sticky-book-bar"
      role="region"
      aria-label="Quick booking actions"
    >
      <a
        href={`tel:${PROPERTY.phone.replace(/[^\d+]/g, "")}`}
        onClick={() => trackClick("sticky:call")}
        className="flex-1 px-4 py-4 flex items-center justify-center gap-2 text-canvas font-mono-label border-r border-canvas/15 active:bg-canvas/10"
        data-testid="sticky-call"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.8 19.8 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.8 19.8 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.13.96.36 1.9.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0122 16.92z" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Call {PROPERTY.phone}
      </a>
      <a
        href={RESERVATION_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackClick("sticky:book")}
        className="flex-1 px-4 py-4 flex items-center justify-center gap-2 bg-ember text-canvas font-mono-label active:brightness-95"
        data-testid="sticky-book"
      >
        Book direct
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
          <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </a>
    </div>
  );
}
